"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperandTypeEnums = exports.OperatorEnums = void 0;
// basic support operators
var OperatorEnums;
(function (OperatorEnums) {
    // logic
    OperatorEnums["And"] = "and";
    OperatorEnums["Or"] = "or";
    // compare
    OperatorEnums["Equal"] = "equal";
    OperatorEnums["NotEqual"] = "notEqual";
    OperatorEnums["Includes"] = "includes";
    OperatorEnums["NotIncludes"] = "notIncludes";
    OperatorEnums["IsNull"] = "isNull";
    OperatorEnums["IsNotNull"] = "isNotNull";
    OperatorEnums["LessThan"] = "lessThan";
    OperatorEnums["LessThanOrEqual"] = "lessThanOrEqual";
    OperatorEnums["GreaterThan"] = "greaterThan";
    OperatorEnums["GreaterThanOrEqual"] = "greaterThanOrEqual";
    // built-in functions
    OperatorEnums["GetNodeOutput"] = "getNodeOutput";
    OperatorEnums["GetObjectProperty"] = "getObjectProperty";
    OperatorEnums["GetArrayObjectProperty"] = "getArrayObjectProperty";
    OperatorEnums["JSONStringify"] = "JSONStringify";
    OperatorEnums["Flatten"] = "flatten";
    OperatorEnums["Length"] = "length";
    OperatorEnums["NewObject"] = "newObject";
})(OperatorEnums = exports.OperatorEnums || (exports.OperatorEnums = {}));
// operand type, can be literal or expression
var OperandTypeEnums;
(function (OperandTypeEnums) {
    OperandTypeEnums["Literal"] = "Literal";
    OperandTypeEnums["Expression"] = "Expression";
})(OperandTypeEnums = exports.OperandTypeEnums || (exports.OperandTypeEnums = {}));
//# sourceMappingURL=expression.interface.js.map